module.exports = __webpack_public_path__ + "img/card_diamond@3x.5c810fe6.png";